<div class="panel d-flex">
  <div class="panel-content">
    <p class="text-sm text-bold mb-1" i18n="@@fees.content.deposit">DEPOSIT</p>
    <h2 class="mb-3 text-bold" i18n="@@fees.wire.title">
      <i class="icon-wiretransferdeposit icon-header"></i>
      <span class="p-1"></span>
      Wire Transfer
    </h2>
    <p class="text-md" i18n="@@fees.wire.info">Deposit money via the standard bank transfer at no fees.</p>
    <p class="text-sm mb-1 text-bold text-start" i18n="@@fees.content.notes">Additional Notes:</p>
    <ul class="list">
      <li i18n="@@fees.wire.list2">Deposit processing might take up to 2 working days based on your bank</li>
      <li i18n="@@fees.wire.list0">BitOasis does not charge any deposit fees</li>
      <li i18n="@@fees.wire.list1">We do not cover any correspondent bank fees or international transfer fees associated with the transfer; Your account will be credited with the amount we receive in our bank account</li>
    </ul>
    <p class="text-sm mb-0" i18n="@@fees.content.country.more">Supported Countries: <strong>UAE, KSA, Kuwait, Bahrain, Oman, Jordan, Algeria, Lebanon, Morocco, Tunisia and more.</strong></p>
  </div>
  <div class="p-2"></div>
  <badge-component class="col-lg-4 col-md-4 col-12"
    title="deposit fee"
    content="0% - Zero Fees"
    i18n-title="@@fees.badge.deposit.title"
    i18n-content="@@fees.badge.deposit.content.zero"
  ></badge-component>
</div>

<div class="panel d-flex">
  <div class="panel-content">
    <p class="text-sm text-bold mb-1" i18n="@@fees.content.depositOnly">FOR DEPOSIT ONLY</p>
    <h2 class="mb-3 text-bold" i18n="@@fees.funding.title">
      <i class="icon-lean icon-header"></i>
      <span class="p-2"></span>
      Easy Funding
    </h2>
    <p class="text-md" i18n="@@fees.funding.info">Easy Funding connects your bank account to your BitOasis account and allows you to make fast and seamless bank-to-bank transfers from our app</p>
    <p class="text-sm mb-1 text-bold text-start" i18n="@@fees.content.notes">Additional Notes:</p>
    <ul class="list">
      <li i18n="@@fees.funding.list0">Deposits are processed in less than 30 minutes once received.</li>
      <li i18n="@@fees.wire.list0">BitOasis does not charge any deposit fees</li>
    </ul>
    <p class="text-sm mb-0" i18n="@@fees.content.country.uae">Supported Countries: <strong>UAE</strong></p>
  </div>
  <div class="p-2"></div>
  <badge-component class="col-lg-4 col-md-4 col-12"
    title="deposit fee"
    content="0% - Zero Fees"
    i18n-title="@@fees.badge.deposit.title"
    i18n-content="@@fees.badge.deposit.content.zero"
  ></badge-component>
</div>

<div class="panel d-flex">
  <div class="panel-content">
    <p class="text-sm text-bold mb-1" i18n="@@fees.content.depositOnly">FOR DEPOSIT ONLY</p>
    <h2 class="mb-3 text-bold" i18n="@@fees.card.title">
      <i class="icon-card-ai icon-header"></i>
      <span class="p-1"></span>
      Card Deposit
    </h2>
    <p class="text-md" i18n="@@fees.card.info">Fund your account in your local currency such as AED{{fiatCurrency!= 'AED' ? ', ' + fiatCurrency : ''}} and more.</p>
    <p class="text-sm mb-1 text-bold text-start" i18n="@@fees.content.notes">Additional Notes:</p>
    <ul class="list">
      <li i18n="@@fees.card.list0">Debit card issuers may charge you lower cash advance transaction fees than credit cards-please check with your card issuer for more details.</li>
      <li i18n="@@fees.card.list1">Use a maximum of 3 of your own cards</li>
      <li i18n="@@fees.card.list2">Payments are only accepted from cards under the customer’s name.</li>
    </ul>
    <p class="text-sm mb-0" i18n="@@fees.card.country.more">Supported Countries: <strong>UAE, Kuwait, Bahrain, Oman, Jordan, Algeria, Lebanon, Morocco, Tunisia and more.</strong></p>
  </div>
  <div class="p-2"></div>
  <badge-component class="col-lg-4 col-md-4 col-12"
    title="deposit fee"
    i18n-title="@@fees.badge.deposit.title"
    content="As low as  {{ccPercentage}}"
    i18n-content="@@fees.badge.deposit.content.aslowas"
  ></badge-component>
</div>

<div class="panel d-flex">
  <div class="panel-content">
    <p class="text-sm text-bold mb-1" i18n="@@fees.content.withdrawal">WITHDRAWAL</p>
    <h2 class="mb-3 text-bold" i18n="@@fees.withdrawal.title">
      <i class="icon-wiretransfer icon-header"></i>
      <span class="p-2"></span>
      Fiat Withdrawal
    </h2>
    <p class="text-md" i18n="@@fees.withdrawal.info">Receive money directly to your bank account.</p>
    <p class="text-sm mb-1 text-bold text-start" i18n="@@fees.content.notes">Additional Notes:</p>
    <ul class="list">
      <li i18n="@@fees.withdrawal.list0">All withdrawal requests received Monday to Saturday before 11 am (UAE Time) are processed on the same day subject to a transfer amount up to AED 0.5M and depending on your bank</li>
      <li i18n="@@fees.withdrawal.list1">If the withdrawal request is submitted post the cut-off time, next banking day processing will apply.</li>
    </ul>
    <p class="text-sm text-italic" i18n="@@fees.withdrawal.list2">*International withdrawals might take from 3-7 days to be processed and funded into your bank account, depending on your bank’s processing time.    </p>
    <p class="text-sm mb-0" i18n="@@fees.content.country.morePart">Supported Countries: <strong>UAE, KSA, Kuwait, Bahrain, Oman</strong></p>
  </div>
  <div class="p-2"></div>
  <div class="col-lg-4 col-md-4 col-12">
    <table class="general country-table">
      <tr class="header">
        <th i18n="@@fees.fiat.table.withdrawalAmount">Withdrawal Amount</th>
        <th i18n="@@fees.fiat.table.withdrawal" class="col-5">Withdrawal fee</th>
      </tr>
      <ng-container *ngIf="country?.code3 =='ARE'">
        <tr>
          <td i18n="@@fees.fiat.table.lessLabel">Up to 25k AED</td>
          <td i18n="@@fees.fiat.table.lessFee">10 AED</td>
        </tr>
        <tr>
          <td i18n="@@fees.fiat.table.moreLabel">More than 25K AED</td>
          <td i18n="@@fees.fiat.table.moreFee">65 AED</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="country?.code3 !='ARE'">
        <ng-container *ngTemplateOutlet="wireTransferFees; context: {item: {country: country?.name, fees: countryWithdrawFiatFees[country?.code3].fiatWithdrawFee, currency: fiatCurrency}}">
        </ng-container>
      </ng-container>
    </table>
  </div>
</div>


<ng-template #wireTransferFees let-item="item">
  <tr *ngIf="item.fees">
    <td>{{item.currency}}</td>
    <td>{{item.fees}}</td>
  </tr>
  <tr>
    <td i18n="@@fees.fiat.table.aed">AED</td>
    <td>65 AED</td>
  </tr>
</ng-template>
